
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import BottomNav from '../../components/feature/BottomNav';

const CarsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [pickupDate, setPickupDate] = useState('');
  const [returnDate, setReturnDate] = useState('');
  const [pickupTime, setPickupTime] = useState('10:00');
  const [returnTime, setReturnTime] = useState('10:00');

  const carCategories = [
    { name: 'اقتصادية', icon: 'ri-car-line', count: 45, price: 120 },
    { name: 'متوسطة', icon: 'ri-car-fill', count: 32, price: 180 },
    { name: 'فاخرة', icon: 'ri-roadster-line', count: 18, price: 350 },
    { name: 'عائلية', icon: 'ri-truck-line', count: 25, price: 220 }
  ];

  const rentalCompanies = [
    { name: 'هرتز', rating: 4.5, logo: 'https://public.readdy.ai/ai/img_res/9c10fb544b7770b1f23c2c266fe878ef.jpg' },
    { name: 'أفيس', rating: 4.3, logo: 'https://readdy.ai/api/search-image?query=icon%20car%20rental%20company%20logo%20Avis%20brand%20automotive%20service%20isolated%20on%20white%20background%20centered%20composition&width=100&height=100&seq=13&orientation=squarish' },
    { name: 'بدجت', rating: 4.1, logo: 'https://readdy.ai/api/search-image?query=icon%20car%20rental%20company%20logo%20Budget%20brand%20automotive%20service%20isolated%20on%20white%20background%20centered%20composition&width=100&height=100&seq=14&orientation=squarish' },
    { name: 'يورب كار', rating: 4.4, logo: 'https://readdy.ai/api/search-image?query=icon%20car%20rental%20company%20logo%20Europcar%20brand%20automotive%20service%20isolated%20on%20white%20background%20centered%20composition&width=100&height=100&seq=15&orientation=squarish' }
  ];

  const featuredCars = [
    {
      id: 1,
      name: 'تويوتا كامري',
      category: 'متوسطة',
      price: 180,
      image: 'https://readdy.ai/api/search-image?query=Toyota%20Camry%20sedan%20car%20silver%20color%20modern%20design%20automotive%20photography%20clean%20background%20professional%20lighting&width=300&height=200&seq=16&orientation=landscape',
      features: ['تكييف', 'نظام ملاحة', 'بلوتوث', 'كاميرا خلفية'],
      transmission: 'أوتوماتيك',
      seats: 5,
      fuel: 'بنزين'
    },
    {
      id: 2,
      name: 'نيسان التيما',
      category: 'متوسطة',
      price: 170,
      image: 'https://readdy.ai/api/search-image?query=Nissan%20Altima%20sedan%20car%20white%20color%20modern%20design%20automotive%20photography%20clean%20background%20professional%20lighting&width=300&height=200&seq=17&orientation=landscape',
      features: ['تكييف', 'نظام ملاحة', 'بلوتوث', 'مقاعد جلدية'],
      transmission: 'أوتوماتيك',
      seats: 5,
      fuel: 'بنزين'
    },
    {
      id: 3,
      name: 'هيونداي إلنترا',
      category: 'اقتصادية',
      price: 120,
      image: 'https://readdy.ai/api/search-image?query=Hyundai%20Elantra%20sedan%20car%20blue%20color%20modern%20design%20automotive%20photography%20clean%20background%20professional%20lighting&width=300&height=200&seq=18&orientation=landscape',
      features: ['تكييف', 'بلوتوث', 'USB', 'مقاعد قماشية'],
      transmission: 'أوتوماتيك',
      seats: 5,
      fuel: 'بنزين'
    }
  ];

  const popularLocations = [
    'مطار الملك خالد الدولي - الرياض',
    'مطار الملك عبدالعزيز الدولي - جدة',
    'مطار الملك فهد الدولي - الدمام',
    'وسط مدينة الرياض',
    'كورنيش جدة',
    'الخبر - الكورنيش'
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm fixed top-0 left-0 right-0 z-10 h-16">
        <div className="flex items-center justify-between h-full px-4">
          <button 
            onClick={() => navigate('/home')}
            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 flex-shrink-0"
          >
            <i className="ri-arrow-right-line text-xl text-gray-700"></i>
          </button>
          <h1 className="text-lg font-semibold text-gray-900 truncate mx-4">تأجير السيارات</h1>
          <button className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 flex-shrink-0">
            <i className="ri-notification-line text-xl text-gray-700"></i>
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="pt-16 pb-20">
        {/* Search Form */}
        <div className="bg-white p-4 shadow-sm">
          <div className="space-y-4">
            {/* Pickup Location */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">مكان الاستلام</label>
              <div className="relative">
                <select className="w-full p-3 pr-10 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white">
                  <option value="">اختر مكان الاستلام</option>
                  {popularLocations.map((location, index) => (
                    <option key={index} value={location}>{location}</option>
                  ))}
                </select>
                <i className="ri-map-pin-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                <i className="ri-arrow-down-s-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
              </div>
            </div>

            {/* Return Location */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">مكان الإرجاع</label>
              <div className="relative">
                <select className="w-full p-3 pr-10 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white">
                  <option value="">اختر مكان الإرجاع</option>
                  {popularLocations.map((location, index) => (
                    <option key={index} value={location}>{location}</option>
                  ))}
                </select>
                <i className="ri-map-pin-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                <i className="ri-arrow-down-s-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
              </div>
            </div>

            {/* Pickup Date & Time */}
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">تاريخ الاستلام</label>
                <input
                  type="date"
                  value={pickupDate}
                  onChange={(e) => setPickupDate(e.target.value)}
                  className="w-full p-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">وقت الاستلام</label>
                <input
                  type="time"
                  value={pickupTime}
                  onChange={(e) => setPickupTime(e.target.value)}
                  className="w-full p-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>
            </div>

            {/* Return Date & Time */}
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">تاريخ الإرجاع</label>
                <input
                  type="date"
                  value={returnDate}
                  onChange={(e) => setReturnDate(e.target.value)}
                  className="w-full p-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">وقت الإرجاع</label>
                <input
                  type="time"
                  value={returnTime}
                  onChange={(e) => setReturnTime(e.target.value)}
                  className="w-full p-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>
            </div>

            {/* Search Button */}
            <button className="w-full bg-blue-600 text-white py-3 rounded-xl font-medium hover:bg-blue-700 transition-colors">
              البحث عن سيارات
            </button>
          </div>
        </div>

        {/* Car Categories */}
        <div className="p-4">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">فئات السيارات</h2>
          <div className="grid grid-cols-2 gap-3">
            {carCategories.map((category, index) => (
              <div key={index} className="bg-white rounded-xl p-4 shadow-sm">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-3">
                  <i className={`${category.icon} text-blue-600 text-xl`}></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-1">{category.name}</h3>
                <p className="text-sm text-gray-600 mb-2">{category.count} سيارة متاحة</p>
                <p className="text-lg font-bold text-blue-600">من {category.price} ر.س/يوم</p>
              </div>
            ))}
          </div>
        </div>

        {/* Rental Companies */}
        <div className="p-4">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">شركات التأجير</h2>
          <div className="grid grid-cols-2 gap-3">
            {rentalCompanies.map((company, index) => (
              <div key={index} className="bg-white rounded-xl p-4 shadow-sm text-center">
                <img
                  src={company.logo}
                  alt={company.name}
                  className="w-16 h-16 mx-auto mb-3 object-contain"
                />
                <h3 className="font-semibold text-gray-900 mb-1">{company.name}</h3>
                <div className="flex items-center justify-center">
                  <i className="ri-star-fill text-yellow-400 text-sm"></i>
                  <span className="text-sm text-gray-600 mr-1">{company.rating}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Featured Cars */}
        <div className="p-4">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">سيارات مميزة</h2>
          <div className="space-y-4">
            {featuredCars.map((car) => (
              <div key={car.id} className="bg-white rounded-xl shadow-sm overflow-hidden">
                <img
                  src={car.image}
                  alt={car.name}
                  className="w-full h-48 object-cover"
                />
                <div className="p-4">
                  <div className="flex items-start justify-between mb-3">
                    <div>
                      <h3 className="font-semibold text-gray-900">{car.name}</h3>
                      <p className="text-sm text-gray-600">{car.category}</p>
                    </div>
                    <div className="text-left">
                      <div className="text-lg font-bold text-blue-600">{car.price} ر.س</div>
                      <div className="text-xs text-gray-500">لليوم الواحد</div>
                    </div>
                  </div>

                  <div className="grid grid-cols-3 gap-2 mb-3 text-xs text-gray-600">
                    <div className="flex items-center">
                      <i className="ri-user-line text-sm ml-1"></i>
                      {car.seats} مقاعد
                    </div>
                    <div className="flex items-center">
                      <i className="ri-settings-line text-sm ml-1"></i>
                      {car.transmission}
                    </div>
                    <div className="flex items-center">
                      <i className="ri-gas-station-line text-sm ml-1"></i>
                      {car.fuel}
                    </div>
                  </div>

                  <div className="flex flex-wrap gap-2 mb-3">
                    {car.features.map((feature, index) => (
                      <span key={index} className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-full">
                        {feature}
                      </span>
                    ))}
                  </div>

                  <button className="w-full bg-blue-600 text-white py-2 rounded-lg font-medium hover:bg-blue-700 transition-colors">
                    احجز الآن
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <BottomNav />
    </div>
  );
};

export default CarsPage;
